import { RootState } from 'store';

export const authSelector = (state: RootState) => state.auth;
export const dictionariesSelector = (state: RootState) => state.dictionaries;
